import { useQuery } from '@tanstack/react-query';

export const getHealthieUser = (): Promise<{ healthieUserId: string }> =>
  fetch('/api/healthie/provider/user').then((res) => res.json());

export const useGetHealthieUser = () =>
  useQuery({ queryKey: ['healthieUser'], queryFn: getHealthieUser });
